export default "__VITE_ASSET__CWsqXkqa__"